import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper';
import {
    ACTION_HELP_DRAWER_CLEAR,
    ACTION_SET_PAGE_HELP_DRAWER,
    ACTION_TOGGLE_HELP_DRAWER,
    HelpDrawerAction,
} from '../actions/helpDrawer';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";
import { Page } from 'src/dtos/Tmd.dtos';

export interface IHelpDrawerState {
    isOpen: boolean,
    page: Page | null
}

const initialState: IHelpDrawerState = {
    isOpen: false,
    page: null
};


function _loading(state: IHelpDrawerState, _isLoading: boolean): IHelpDrawerState {
    const newState: IHelpDrawerState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function toggleHelpDrawer(state: IHelpDrawerState,
    isOpen: boolean
): IHelpDrawerState {
    const newState: IHelpDrawerState = update(state, {
        isOpen: {
            $set: isOpen
        }
    });

    return newState;
}

function setPage(state: IHelpDrawerState,
    page: Page | null
): IHelpDrawerState {
    const newState: IHelpDrawerState = update(state, {
        page: {
            $set: page
        }
    });

    return newState;
}

function clear(state: IHelpDrawerState, propertiesToClear?: string[]): IHelpDrawerState {

    if (!propertiesToClear) {
        const newState: IHelpDrawerState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const HelpDrawerReducer: Reducer<IHelpDrawerState> = (state: IHelpDrawerState = initialState, action: HelpDrawerAction) => {
    switch (action.type) {
        case ACTION_HELP_DRAWER_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TOGGLE_HELP_DRAWER:
            return toggleHelpDrawer(state, action.isOpen);
        case ACTION_SET_PAGE_HELP_DRAWER:
            return setPage(state, action.page);
    }

    return state;
}

export default HelpDrawerReducer;